import React from 'react';
import { Select } from 'antd';


const { Option, OptGroup } = Select;

export const states = [
    {
        country: "US",
        states: [
            "AL",
            "AK",
            "AZ",
            "AR",
            "CA",
            "CO",
            "CT",
            "DE",
            "DC",
            "FL",
            "GA",
            "HI",
            "ID",
            "IL",
            "IN",
            "IA",
            "KS",
            "KY",
            "LA",
            "ME",
            "MD",
            "MA",
            "MI",
            "MN",
            "MS",
            "MO",
            "MT",
            "NE",
            "NV",
            "NH",
            "NJ",
            "NM",
            "NY",
            "NC",
            "ND",
            "OH",
            "OK",
            "OR",
            "PA",
            "PR",
            "RI",
            "SC",
            "SD",
            "TN",
            "TX",
            "UT",
            "VT",
            "VA",
            "WA",
            "WV",
            "WI",
            "WY",
            "AA",
            "AE",
            "AP",
            "GU",
            "VI",
        ]
    }, {
        country: 'CA',
        states: [
            "AB",
            "BC",
            "MB",
            "NB",
            "NL",
            "NT",
            "NS",
            "NU",
            "ON",
            "PE",
            "QC",
            "SK",
            "YT",
        ]
    }, {
        country: 'Other',
        states: [
            "N/A"
        ]
    }
];

const StateDD = (props) => (
<Select defaultValue={props.value} value={props.value} {...props}>
    {states.map(e =>
         <OptGroup label={e.country} key={e.country}>
             {
                 e.states.map(s => 
                    <Option value={s} key={s}>{s}</Option>
                )
             }
         </OptGroup>
    )}
 </Select>
);


export default StateDD;